var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M943 903L943 931",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 943.5,
    cy: 898.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M938.987 898.19C938.987 894.283 942.288 891.117 946.358 891.117C946.943 891.117 947.511 891.184 948.056 891.308C946.742 890.48 945.187 890 943.519 890C938.814 890 935 893.806 935 898.5C935 903.194 938.814 907 943.519 907C945.814 907 947.895 906.093 949.427 904.62C948.492 905.032 947.454 905.263 946.358 905.263C942.288 905.263 938.987 902.096 938.987 898.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M952.402 897.6L952.37 895.146L950.535 896.719L948.304 896.056L949.112 898.337L947.765 900.381L950.1 900.218L951.499 902.144L952.133 899.763L954.345 898.909L952.402 897.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.eff4f1b64fd8fafb633bd93fb9e4c1cb.svg";
export { ForwardRef as ReactComponent };